import { render, staticRenderFns } from "./SaleTicketDetails.vue?vue&type=template&id=1083c3ec&lang=pug&"
import script from "./SaleTicketDetails.vue?vue&type=script&lang=js&"
export * from "./SaleTicketDetails.vue?vue&type=script&lang=js&"
import style0 from "./SaleTicketDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SaleTicketDetails.vue"
export default component.exports